"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TriplePlanEntryWidgetDataSchema = exports.TriplePlanEntryItemSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
exports.TriplePlanEntryItemSchema = zod_1.z.object({
    id: zod_1.z.string(),
    title: zod_1.z.string(),
    subtitle: zod_1.z.string(),
    badge: zod_1.z.object({ type: zod_1.z.enum(['D_DAY']), title: zod_1.z.string() }),
    image: zod_1.z.object({ url: zod_1.z.string() }),
    action: common_1.CommonResponseItemActionDto,
    serverLogMeta: zod_1.z.record(zod_1.z.unknown()).optional(),
});
exports.TriplePlanEntryWidgetDataSchema = zod_1.z.object({
    header: zod_1.z.object({ title: zod_1.z.string(), subtitle: zod_1.z.string().optional() }),
    items: zod_1.z.array(exports.TriplePlanEntryItemSchema),
});
